
    import * as React from 'react';

    const GenderWomens12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" style={svgStyle}><path d="M6 9a3 3 0 100-6 3 3 0 000 6" fillRule="evenodd" /></svg>
        </div>
      );
    };

    GenderWomens12.displayName = 'GenderWomens12';

    export default GenderWomens12;
  